import React from 'react';
import { Typography } from 'src/components/PulseUI';
import { MIN_VOLUME_YEAR_STR, MAX_VOLUME_YEAR_STR } from 'src/components/constants';

const TableVolumeHeader = ({ type, selectedType, yearRange }) => {
  return (
    <div className="flex h-auto items-center gap-4 self-stretch">
      <div className="flex flex-col items-start flex-1">
        <Typography variant="h4" color="primary" className="leading-[155%]">
          Volume
        </Typography>
        <Typography variant="caption" color="secondary" className="leading-[144%]">
          {`Number of ${selectedType} `}
          <strong>{type}</strong>
          {` by the provider for your pre-saved targeting criteria from ${
            yearRange?.gte || MIN_VOLUME_YEAR_STR
          } - ${yearRange?.lte || MAX_VOLUME_YEAR_STR}.`}
        </Typography>
      </div>
    </div>
  );
};

export default TableVolumeHeader;
